export const TIME_ENABLED = 'TIME_ENABLED';
export const ADDING_TIME = 'ADDING_TIME';
export const SET_TIME_RECORDS = 'SET_TIME_RECORDS';
export const LOAD_TIME_CONFIG = 'LOAD_TIME_CONFIG';
export const ADD_TIME_RECORD = 'ADD_TIME_RECORD';
export const UPDATE_TIME_RECORD = 'UPDATE_TIME_RECORD';
export const DELETE_TIME_RECORD = 'DELETE_TIME_RECORD';
export const DELETE_RELATED_TO_TIME_RECORD = 'DELETE_RELATED_TO_TIME_RECORD';
export const IS_ERROR_LOADING_TIME_RECORDS = 'IS_ERROR_LOADING_TIME_RECORDS';
export const IS_ERROR_LOADING_TIME_CONFIG = 'IS_ERROR_LOADING_TIME_CONFIG';
export const SHOW_TIME_REMINDER = 'SHOW_TIME_REMINDER';
export const SEND_ON_SAVE = 'SEND_ON_SAVE';
export const FORCE_EMAIL_SAVE = 'FORCE_EMAIL_SAVE';
export const SET_SELECTED_TIME_RECORD = 'SET_SELECTED_TIME_RECORD';
export const SET_TIME_PROCESSING = 'SET_TIME_PROCESSING';
export const SET_BILLING_CODE_SETS = 'SET_BILLING_CODE_SETS';
export const CACHE_TIMEKEEPERS_SELECTED = 'CACHE_TIMEKEEPERS_SELECTED';

export const setTimeEnabled = (status) => {
  return {
    type: TIME_ENABLED,
    status,
  };
};

export const addingTime = (value) => {
  return {
    type: ADDING_TIME,
    payload: value,
  };
};

export const setTimeRecords = (value) => {
  return {
    type: SET_TIME_RECORDS,
    payload: value,
  };
};

export const addTimeRecord = (value) => {
  return {
    type: ADD_TIME_RECORD,
    payload: value,
  };
};

export const updateTimeRecord = (index, value) => {
  return {
    type: UPDATE_TIME_RECORD,
    index,
    payload: value,
  };
};

export const deleteTimeRecord = (index) => {
  return {
    type: DELETE_TIME_RECORD,
    index,
  };
};

export const deleteRelatedToTimeRecord = (relatedToId) => {
  return {
    type: DELETE_RELATED_TO_TIME_RECORD,
    relatedToId,
  };
};

export const loadConfig = (config) => ({
  type: LOAD_TIME_CONFIG,
  config,
});

export const isErrorLoadingTimeRecords = (status) => {
  return {
    type: IS_ERROR_LOADING_TIME_RECORDS,
    status,
  };
};

export const isErrorLoadingTimeConfig = (status) => {
  return {
    type: IS_ERROR_LOADING_TIME_CONFIG,
    status,
  };
};

export const showTimeReminder = (status) => {
  return {
    type: SHOW_TIME_REMINDER,
    status,
  };
};

export const sendOnSave = (status) => {
  return {
    type: SEND_ON_SAVE,
    status,
  };
};

export const forceEmailSave = (status) => {
  return {
    type: FORCE_EMAIL_SAVE,
    status,
  };
};

export const setSelectedTimeRecord = (record) => {
  return {
    type: SET_SELECTED_TIME_RECORD,
    record,
  };
};

export const setTimeProcessing = (status) => {
  return {
    type: SET_TIME_PROCESSING,
    status,
  };
};

export const setBillingCodesSets = (billingCodeSets) => {
  return {
    type: SET_BILLING_CODE_SETS,
    billingCodeSets,
  };
};

export const cacheTimekeeperSelected = (OwnerId, displayName) => {
  return {
    type: CACHE_TIMEKEEPERS_SELECTED,
    payload: { OwnerId, displayName },
  };
};
